<template>
  <section class="section">
    <div class="container">
      <div class="section__header section__header--center">
        <span class="section__label">Платформа</span>
        <h2 class="section__title">Не только расчёт премий — целая платформа</h2>
        <p class="section__subtitle">Один контур для оргструктуры и доступа, KPI, расчёта зарплаты, задач и личных кабинетов сотрудников</p>
      </div>
      <div class="grid-3">
        <div v-for="feat in features" :key="feat.title" class="feat-card">
          <div class="feat-card__icon">
            <ui-icon :name="feat.icon" :size="26" />
          </div>
          <h3 class="feat-card__title">{{ feat.title }}</h3>
          <p class="feat-card__text">{{ feat.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UiIcon from '../ui/UiIcon.vue'
export default {
  name: 'FeaturesSection',
  components: { UiIcon },
  data() {
    return {
      features: [
        {
          icon: 'network',
          title: 'Орг. структура',
          text: 'Подразделения, должности и сотрудники в единой интерактивной схеме — основа всех расчётов и прав доступа.',
        },
        {
          icon: 'bar-chart',
          title: 'Индикаторы и формулы',
          text: 'Гибкая настройка показателей, переменных и правил расчёта для любой должности — без программиста.',
        },
        {
          icon: 'target',
          title: 'KPI и премии',
          text: 'Показатели с весами в KPI-карте — её итог автоматически идёт множителем в премию сотрудника.',
        },
        {
          icon: 'calculator',
          title: 'Расчёт зарплаты',
          text: 'Автоматический расчёт постоянной и премиальной частей по всей компании — за минуты, с историей изменений.',
        },
        {
          icon: 'users',
          title: 'Роли и доступ',
          text: 'Кто что видит и правит — под контролем. Настройки меняют только HR и админ, руководитель согласует, сотрудник видит лишь свои начисления. Роли делегируются на подразделение каскадом.',
        },
        {
          icon: 'eye',
          title: 'Личный кабинет',
          text: 'Каждый сотрудник видит свои начисления и пошаговую расшифровку — на компьютере и телефоне.',
        },
      ],
    }
  },
}
</script>

<style scoped>
.feat-card {
  padding: 28px;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  transition: var(--transition);
  cursor: pointer;
}
.feat-card:hover {
  border-color: var(--primary);
  box-shadow: var(--shadow);
}
.feat-card__icon {
  width: 56px;
  height: 56px;
  background: var(--primary-light);
  color: var(--primary);
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.feat-card__title {
  font-size: 1.0625rem;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--dark);
}
.feat-card__text { color: var(--gray); font-size: 0.9375rem; line-height: 1.6; }
</style>
